<template>
  <div class="updates-content">
    <div class="content-header">
      <h3>{{ t.update }}</h3>
    </div>
    <!-- listing updates -->
    <div v-if="Array.isArray(updates)&&updates.length">
      <div class="updates-list-container">
        <paginate 
            tag="ul" 
            ref="paginator" 
            name="updatesPaginated" 
            :list="updates" 
            :per="40" 
            :refreshCurrentPage="true" 
            class="updates-list">
          <!-- list elements -->
          <li 
              v-for="(a,i) in paginated('updatesPaginated')" 
              :key="i" 
              v-html="fixText(a.Content)"></li>
        </paginate>
      </div>
      <paginate-links 
          v-if="updates.length" 
          for="updatesPaginated" 
          :limit="3" 
          :show-step-links="true" 
          :hide-single-page="true"></paginate-links>
    </div>
    <!-- response loading -->
    <template v-else>
      <div class="spinner" v-if="Array.isArray(updates) && !updates.length">
        <div class="rect1"></div>
        <div class="rect2"></div>
        <div class="rect3"></div>
        <div class="rect4"></div>
        <div class="rect5"></div>
      </div>
      <p class="response-error" v-if="updates==undefined">
        <span>{{ lng == 'tr' ? 'Kayıt bulunamadı' : 'No Records Found' }}</span>
      </p>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      paginate: ['updatesPaginated']
    };
  },
  computed: {
    ...mapGetters(['t', 'lng', 'updates'])
  },
  methods: {
    fixText(value) {
      var txt = document.createElement('textarea');
      txt.innerHTML = value.replace(/(<([^>]+)>)/gi, '');
      return txt.value;
    }
  },
  created() {
    this.$store.dispatch('updates', this.lng);
    this.$scrollTo('body', this.$store.state.scrollSpeed);
  }
};
</script>

<style lang="scss" scoped>
.updates-content {
  padding: 20px;
}
.updates-list-container {
  width: 80%;
  margin: 0 auto;
  margin-top: 20px;
  padding: 0 30px;
  @media screen and (max-width: 760px) {
    width: 100%;
  }
  ul.updates-list {
    list-style-type: disc;
    list-style-position: inside;
    li {
      font-size: 16px;
      color: #777;
      padding: 10px 0;
      line-height: 30px;
      cursor: default;
    }
  }
}
</style>
